import React from 'react';
import { ArrowLeft, ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';

const TopBar = ({ title, showBack = false, showCart = false }) => {
  const navigate = useNavigate();
  const { getItemCount } = useCart();
  const itemCount = getItemCount();

  return (
    <div className="sticky top-0 z-40 bg-background border-b border-border backdrop-blur-lg">
      <div className="flex items-center justify-between h-14 px-4 max-w-md mx-auto">
        {showBack ? (
          <button
            data-testid="back-button"
            onClick={() => navigate(-1)}
            className="p-2 -ml-2 hover:bg-muted rounded-full transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        ) : (
          <div className="w-9" />
        )}

        <h1 className="font-['Outfit'] text-lg font-bold text-foreground truncate px-2">
          {title}
        </h1>

        {showCart ? (
          <button
            data-testid="cart-button"
            onClick={() => navigate('/cart')}
            className="p-2 -mr-2 hover:bg-muted rounded-full transition-colors relative"
          >
            <ShoppingCart className="w-5 h-5" />
            {itemCount > 0 && (
              <span className="absolute top-0 right-0 bg-accent text-accent-foreground text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
                {itemCount}
              </span>
            )}
          </button>
        ) : (
          <div className="w-9" />
        )}
      </div>
    </div>
  );
};

export default TopBar;
